import React from 'react';
import HomeModalShell from '../../home/components/HomeModalShell';
import styles from '../Profile.module.css';

interface ProfileFacebookPageCreationModalProps {
  isOpen: boolean;
  description: string;
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onCreatePage: () => void;
  onRetry: () => void;
}

const ProfileFacebookPageCreationModal: React.FC<ProfileFacebookPageCreationModalProps> = ({
  isOpen,
  description,
  loading,
  error,
  onClose,
  onCreatePage,
  onRetry,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <HomeModalShell
      backdropClassName={styles.editorModalBackdrop}
      panelClassName={styles.socialModalCard}
      ariaLabelledBy="profile-facebook-page-creation-title"
      ariaDescribedBy="profile-facebook-page-creation-description"
      onClose={onClose}
      closeDisabled={loading}
    >
      <div className={styles.editorModalHeader}>
        <div>
          <h2 id="profile-facebook-page-creation-title" className={styles.editorModalTitle}>
            Create a Facebook Page to Continue
          </h2>
          <p id="profile-facebook-page-creation-description" className={styles.editorModalDescription}>
            {description}
          </p>
        </div>
        <button
          type="button"
          className={styles.editorModalClose}
          onClick={onClose}
          disabled={loading}
          aria-label="Close Facebook Page creation dialog"
        >
          ×
        </button>
      </div>

      <div className={styles.facebookPageCreationBody}>
        <div className={styles.facebookPageCreationCallout}>
          This Facebook connection links a Page you manage. We did not find any Pages on the Facebook account you just
          used.
        </div>

        <p className={styles.editorHint}>
          Create a Facebook Page in a new tab, then come back here and retry the connection once the Page exists.
        </p>

        {error ? (
          <div className={`${styles.editorMessage} ${styles.editorMessageError}`}>
            {error}
          </div>
        ) : null}

        <div className={styles.editorModalActions}>
          <button
            type="button"
            className={`${styles.editorModalButton} ${styles.editorModalButtonSecondary}`}
            onClick={onRetry}
            disabled={loading}
          >
            {loading ? 'Opening Facebook...' : 'I Have a Page, Try Again'}
          </button>
          <button
            type="button"
            className={`${styles.editorModalButton} ${styles.editorModalButtonPrimary}`}
            onClick={onCreatePage}
            disabled={loading}
          >
            Create Facebook Page
          </button>
        </div>
      </div>
    </HomeModalShell>
  );
};

export default React.memo(ProfileFacebookPageCreationModal);
